export class StockMaxMinImportModel {
  counter: number = 0;
  inventoryCode: number = 0;
  branchCode: number = 0;
  storeCode: number = 0;
  articleCode: number = 0;
  stockMin: number = 0;
  stockMax: number = 0;
  storeLocation: string | null = null;

  constructor(
    counter: number = 0,
    inventoryCode: number = 0,
    branchCode: number = 0,
    storeCode: number = 0,
    articleCode: number = 0,
    stockMin: number = 0,
    stockMax: number = 0,
    storeLocation: string | null = null
  ) {
    this.counter = counter;
    this.inventoryCode = inventoryCode;
    this.branchCode = branchCode;
    this.storeCode = storeCode;
    this.articleCode = articleCode;
    this.stockMin = stockMin;
    this.stockMax = stockMax;
    this.storeLocation = storeLocation;
  }
}